var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from '@airtel/air-design-system';
import { Image, View } from 'react-native';
import { getCardSlideStyles } from './CardSlideStyles';
export var CardSlide = props => {
  var _a, _b;
  var item = props.item,
    style = props.style,
    isLargeScreen = props.isLargeScreen,
    restProps = __rest(props, ["item", "style", "isLargeScreen"]);
  var cardSlideStyles = getCardSlideStyles(props);
  var typographyType = isLargeScreen ? 'body-para-lg-bold' : 'body-para-xs-bold';
  return _jsxs(View, Object.assign({
    style: style
  }, restProps, {
    children: [_jsx(Image, {
      style: [cardSlideStyles.cardSlideImage, item === null || item === void 0 ? void 0 : item.cardImageStyle],
      source: {
        uri: isLargeScreen ? (_a = item === null || item === void 0 ? void 0 : item.imageUrl) === null || _a === void 0 ? void 0 : _a.desktop : (_b = item === null || item === void 0 ? void 0 : item.imageUrl) === null || _b === void 0 ? void 0 : _b.mobile
      }
    }), (item === null || item === void 0 ? void 0 : item.title) && _jsx(Typography, {
      style: cardSlideStyles.cardSlideTitle,
      text: item.title,
      type: typographyType
    })]
  }));
};